import axios from '@/plugins/axios'
import store from '@/store'

const donateWithScrivPro = async id => {
  try {
    const response = await axios.post(`users/${id}/donate/scriv-pro`, {
      _method: 'PUT'
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const me = async function () {
  try {
    const response = await axios.get('users/me')
    const { data } = response

    store.dispatch('users/setUser', { user: data })

    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getUser = async username => {
  try {
    const response = await axios.get(`users/${username}`)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getUsers = async ({ search = null, page = 1 }) => {
  try {
    const params = {
      page: page
    }
    if (search) params.search = search
    const response = await axios.get('users', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getPosts = async function ({
  userId = null,
  page = 1,
  sort = null,
  postType = null,
  orderBy = null
}) {
  try {
    const params = {}
    params.user_id = userId
    params.page = page
    if (sort) params.sort = sort
    if (orderBy) params.order_by = orderBy
    if (postType) params.type = postType

    const response = await axios.get('posts', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const update = async (id,
  {
    name = undefined,
    email = undefined,
    document = undefined,
    phone = undefined,
    username = undefined,
    description = undefined,
    cover = undefined,
    avatar = undefined,
    social: { twitter, facebook, instagram, linkedin, youtube, external } = {},
    // eslint-disable-next-line camelcase
    user_default_cover = undefined,
    // eslint-disable-next-line camelcase
    user_default_avatar = undefined
  }) => {
  try {
    const form = new FormData()
    if (name !== undefined) form.append('name', name)
    if (email !== undefined) form.append('email', email)
    if (document !== undefined) form.append('document', document)
    if (phone !== undefined) form.append('phone', phone)
    if (username !== undefined) form.append('username', username)
    if (description !== undefined) form.append('description', description || '')
    if (cover) form.append('cover', cover)
    // eslint-disable-next-line camelcase
    if (user_default_cover) form.append('user_default_cover', user_default_cover)
    if (avatar) form.append('avatar', avatar)
    // eslint-disable-next-line camelcase
    if (user_default_avatar) form.append('user_default_avatar', user_default_avatar)
    if (twitter !== undefined) form.append('social_twitter', twitter || '')
    if (facebook !== undefined) form.append('social_facebook', facebook || '')
    if (instagram !== undefined) form.append('social_instagram', instagram || '')
    if (linkedin !== undefined) form.append('social_linkedin', linkedin || '')
    if (youtube !== undefined) form.append('social_youtube', youtube || '')
    if (external !== undefined) form.append('social_external', external || '')
    form.append('_method', 'PUT')
    const response = await axios.post(`users/${id}`, form, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const destroyAccount = async id => {
  try {
    const response = await axios.post(`users/${id}`, {
      _method: 'DELETE'
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const updateRecipient = async ({ document, phone }) => {
  try {
    const params = {
      document: document,
      phone: phone,
      _method: 'PUT'
    }
    const response = await axios.post('users/recipient/update', params)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  donateWithScrivPro,
  update,
  getPosts,
  getUser,
  getUsers,
  destroyAccount,
  me,
  updateRecipient
}
